<template>
    <el-tooltip
      placement="right-start"
      effect="light"
      popper-class="custom-tooltip-popper"
      :show-arrow="false"
    >
      <template #content>
        <div class="tooltip-content">
          <div
            v-for="(item, index) in items"
            :key="index"
            class="tooltip-item"
            @click="item.onClick"
          >
            <img
              :src="item.icon"
              :alt="item.label"
              class="tooltip-icon"
            />
            <span class="tooltip-label" :style="{ color: item.color || '#333' }">
              {{ item.label }}
            </span>
          </div>
        </div>
      </template>
  
      <slot>
        <span class="more-icon">
          <i class="el-icon-more" />
        </span>
      </slot>
    </el-tooltip>
  </template>
  
  <script>
  export default {
    name: 'TooltipMenu',
    props: {
      items: {
        type: Array,
        required: true,
        default: () => [],
      },
    },
  }
  </script>
  
  <style scoped>
  .more-icon {
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    transition: background-color 0.2s;
  }
  
  .more-icon:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
  
  /* Tooltip content style */
  .tooltip-content {
    display: flex;
    flex-direction: column;
    background-color: white;
    border-radius: 8px;
    padding: 0px 0;
    min-width: 100px;
  }
  
  /* Each item */
  .tooltip-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 16px;
    cursor: pointer;
    transition: background-color 0.2s;
  }
  
  .tooltip-item:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
  
  /* Icon in item */
  .tooltip-icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }
  
  /* Label */
  .tooltip-label {
    font-size: 14px;
    line-height: 1.4;
    color: #333;
    white-space: nowrap;
  }
  
  </style>